import { createSlice } from '@reduxjs/toolkit';

import { ITINERARIES_ITEM_TYPES } from 'constants/index';

export const ITINERARIES_ITEM_TYPE_TO_KEY_MAP = {
  [ITINERARIES_ITEM_TYPES.LOOKBOOK]: 'lookbooks',
  [ITINERARIES_ITEM_TYPES.ITINERARY]: 'itineraries',
  [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: 'guestPortals',
};

const initialState = {
  list: [],
  events: [],
  meta: {
    totalCount: 0,
    totalPages: 0,
  },
  searchResultCounters: {},
  isLoading: false,
};

const slice = createSlice({
  name: 'tourRequests',
  initialState,
  reducers: {
    updateTourRequestRecentEventAction(state, action) {
      const { id, recentEvent, itinerariesItemType } = action.payload;
      const key = ITINERARIES_ITEM_TYPE_TO_KEY_MAP[itinerariesItemType];

      const tourRequestIndex = state.list.findIndex((t) => t[key]?.map((it) => it.id).includes(id));

      if (tourRequestIndex !== -1) {
        state.list[tourRequestIndex].recentEvent = recentEvent;
      }
    },
  },
});

export const { updateTourRequestRecentEventAction } = slice.actions;

export default slice.reducer;
